<template>
    <form id="card_to_card_form" class="border p-2">
        <kt-row>
            <kt-col xs="12" class="mb-5">
        <span v-if="form_data.logo == null">
            <img src="/assets/media/image-not-found.png" style="max-width:300px" class="d-block m-auto"
                 :title="$t('label.image_not_found')"/>
        </span>
                <span v-else>
            <img :src="form_data.logo" style="max-width:300px" class="d-block m-auto">
        </span>
            </kt-col>
            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-label for="user_full_name">
                        {{ $t('label.User_full_name') }} {{ ' :' }}
                    </kt-form-label>
                    <router-link :to="'/users/'+ form_data.user_id +'/details'">
                        {{ form_data.user_fullname }}
                    </router-link>
                </kt-form-group>
            </kt-col>

            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-label for="farsi_name">
                        {{ $t('label.farsi_name') }}
                    </kt-form-label>
                    <kt-form-control
                        id="farsi_name"
                        name="farsi_name"
                        v-model="form_data.farsi_name"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-label for="english_name">
                        {{ $t('label.english_name') }}
                    </kt-form-label>
                    <kt-form-control
                        id="english_name"
                        name="english_name"
                        v-model="form_data.english_name"
                        dir="ltr"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-label for="deposit_sequence">
                        {{ $t('label.gateway_id') }}
                    </kt-form-label>
                    <kt-form-control
                        id="deposit_sequence"
                        name="deposit_sequence"
                        disabled
                        :value="form_data.sequence"
                        dir="ltr"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>

            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-label for="created_at">
                        {{ $t('label.created_at') }}
                    </kt-form-label>
                    <kt-form-control
                        dir="ltr"
                        id="created_at"
                        name="created_at"
                        disabled
                        :value="form_data.created_at"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-label for="callback_address">
                        {{ $t('label.callback_address') }}
                    </kt-form-label>
                    <kt-form-control
                        id="callback_address"
                        name="callback_address"
                        v-model="form_data.callback_address"
                        dir="ltr"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-label for="website">
                        {{ $t('label.website_address') }}
                    </kt-form-label>
                    <kt-form-control
                        id="website"
                        name="website"
                        v-model="form_data.website"
                        dir="ltr"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-label for="server_ip">
                        {{ $t('label.server_ip') }}
                    </kt-form-label>
                    <kt-form-control
                        id="server_ip"
                        name="server_ip"
                        v-model="form_data.server_ip"
                        dir="ltr"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-label>
                        {{ $t('card_to_card.verify_page_address') }}
                    </kt-form-label>
                    <kt-form-select
                        size="3"
                        id="verify_page_address"
                        name="verify_page_address"
                        v-model="form_data.verify_page_address"
                    >
                        <option
                            v-bind:key="index"
                            v-for="(verify_address, index) in form_data.verify_page_addresses"
                            v-bind:value="verify_address"
                            :selected="form_data.verify_address === verify_address"
                        >
                            {{ verify_address }}
                        </option>
                    </kt-form-select>
                </kt-form-group>
            </kt-col>
            <kt-col xs="12" style="text-align: end">
                <kt-form-action class="mt-4">
                    <kt-button
                        class="m-2"
                        size="md"
                        variant="success"
                        type="button"
                        @click="submit"
                        v-bind:wide="true"
                        id="card_to_card_btn"
                    >
                        {{ $t('btn.edit') }}
                    </kt-button>
                </kt-form-action>
            </kt-col>
        </kt-row>
    </form>
</template>

<script>
import $ from 'jquery';
import {KTApp} from '@/plugins/core/app';
import {KTUtil} from '@/plugins/core/util';
import {cardToCardService} from '@/common/api.service';
import {i18n} from '@/plugins/i18n';
import {mapGetters} from "vuex";
import {depositDestinationBanks, depositDestinationBankStr} from "@/constants/deposit";
import toastr from "toastr";

export default {
    data() {
        return {
            depositDestinationBanks, depositDestinationBankStr,
        };
    },
    computed: {
        ...mapGetters('cardToCard', [
            'form_data', 'status'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    mounted() {
        this.afterDispatch()
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            });
        },
        submit() {
            let form = $('#card_to_card_form')
            let btn = $('#card_to_card_btn')
            form.validate({
                rules: {
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    callback_address: {
                        required: true
                    },
                    verify_page_address: {
                        required: true
                    },
                    website: {
                        required: true
                    },
                }
            });


            if (!form.valid()) {
                return
            }
            let has_error = false
            if (!this.checkIfIsPersian(this.form_data.farsi_name)) {
                form.validate().showErrors({
                    farsi_name: i18n.t('pos.validations.enter_persian')
                })
                has_error = true;
            }
            if (!this.checkIfIsEnglish(this.form_data.english_name)) {
                form.validate().showErrors({
                    english_name: i18n.t('pos.validations.enter_english')
                })
                has_error = true;
            }

            if (has_error)
                return;

            KTApp.progress(btn)

            let params = {
                farsi_name: this.form_data.farsi_name,
                english_name: this.form_data.english_name,
                callback_address: this.form_data.callback_address,
                website: this.form_data.website,
                server_ip: this.form_data.server_ip,
                verify_page_address: this.form_data.verify_page_address
            }

            cardToCardService.adminUpdateGatewayInfo(this.form_data.id, params).then(response => {
                this.showMsg(form, 'success', response.data.message);
                KTUtil.scrollTop();
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
    }
}
</script>

<style>

</style>